import type { CaptionDraft } from '../types';
import { notifyCaptionsChanged } from './captionsChangedSignal';

type FingerprintedDraft = Pick<CaptionDraft, 'key' | 'publishStatus' | 'processingStatus' | 'hasContent'>;

const captionListFingerprints = new Map<string, string>();

function fingerprintCaptionList(drafts: FingerprintedDraft[]): string {
  return drafts
    .map((draft) => `${draft.key}:${draft.publishStatus}:${draft.processingStatus}:${draft.hasContent}`)
    .sort()
    .join('|');
}

/**
 * Raises `notifyCaptionsChanged(videoKey)` for a freshly loaded caption-draft list unless its fingerprint
 * (each draft's key, publish status, processing status and content flag, in any order) is identical to the
 * previous list loaded for the same video. The first list loaded for a video therefore always notifies.
 */
export function notifyIfCaptionListChanged(videoKey: string, drafts: FingerprintedDraft[]): void {
  const fingerprint = fingerprintCaptionList(drafts);
  const previousFingerprint = captionListFingerprints.get(videoKey);
  captionListFingerprints.set(videoKey, fingerprint);
  if (previousFingerprint !== fingerprint) {
    notifyCaptionsChanged(videoKey);
  }
}
